<template>
	<v-list-item style="border: 1px solid #e0e0e0; border-radius: 5px">
		<v-list-item-icon class="mr-3">
			<v-icon color="primary">mdi-file-document</v-icon>
		</v-list-item-icon>
		<v-list-item-content>
			<v-list-item-title>
				<strong>{{consent.title}}</strong>
			</v-list-item-title>
			<v-list-item-subtitle></v-list-item-subtitle>
		</v-list-item-content>
		<v-list-item-action>
			<v-row no-gutters align="center">
				<v-btn icon @click="showEdit = true">
					<v-icon color="primary">mdi-pencil</v-icon>
				</v-btn>
        <v-btn icon @click="showDeleteConsent = true">
          <v-icon color="primary">delete</v-icon>
				</v-btn>
			</v-row>
		</v-list-item-action>
    <DeleteConfirmationDialog
			v-model="showDeleteConsent"
			item="consent"
			@delete="removeConsent"
		/>
		<v-dialog v-model="showEdit" max-width="70%" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Edit</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<v-form ref="form">
						<v-row no-gutters>
							<v-col cols="6">
								<v-text-field
									v-model="consent.title"
									:label="$gettext('Name')"
									outlined
									:rules="[required]"
								></v-text-field>
							</v-col>
							<v-col cols="12" class="mb-3">
								<h3 v-translate>Consent</h3>
							</v-col>
							<v-col cols="12">
								<span v-translate class="font-weight-bold">Older</span>
								<RichTextEditor class="mt-2" ref="editorOlder" :consent="true" :text="consent.consent_text" />
							</v-col>
							<v-col cols="12" class="my-2">
								<span v-translate class="font-weight-bold">Minor</span>
								<RichTextEditor class="mt-2" ref="editorMinor" :consent="true" :isMinor="true" :text="consent.consent_minor_text" />
								</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showEdit = false">
						<translate key="close">Close</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="editConsent">
						<translate key="save">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-list-item>
</template>

<script>
import RichTextEditor from "@/components/RichTextEditor.vue";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";

export default {
  name: "PreMadeConsentItem",
  props: ["consent"],
  components: {
    RichTextEditor,
    DeleteConfirmationDialog
  },
  data: () => ({
    showEdit: false,
    showDeleteConsent: false,
  }),
  computed: {
    required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    editConsent() {
      if (this.$refs.form.validate()) {
        const form = new FormData();
        form.append("title", this.consent.title);
        form.append("consent_text", this.$refs.editorOlder.getHTML());
        form.append("consent_minor_text", this.$refs.editorMinor.getHTML());
				axios
					.post("/pre-made-consent/" + this.consent.id + "/edit", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
							this.showEdit = false;
						}
					})
					.catch(error => console.log(error));
			}
    },
    removeConsent() {
      axios
				.post("/pre-made-consent/" + this.consent.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted") {
            this.$emit("remove", this.consent);
            this.showDeleteConsent = false;
					}
				})
				.catch(error => console.log(error));
		}
  }
}
</script>